import { Alert } from "react-bootstrap";

const ErrorMessage = ({error}) => (
    error?.length > 0 && (<Alert variant="danger">{error?.map((val, index) => <li key={index}>{val}</li>)}</Alert>)
    
) 
export default ErrorMessage